import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { Constant } from '../../constant';
import { ToastUtil } from '../../util/toast-util';
import { Approver } from '../../model/my-event';
import { ApproverSelectDialogComponent } from '../approver-select-dialog/approver-select-dialog.component';
import { GeneralYesNoDialogComponent } from '../general-yes-no-dialog/general-yes-no-dialog.component';
import { CommonUtil } from '../../util/common-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';
import { MatDividerModule } from '@angular/material/divider';

interface DialogData {
  eventId: string;
  documentType: 'plan' | 'report';
}

@Component({
  selector: 'app-approval-request-dialog',
  templateUrl: './approval-request-dialog.component.html',
  styleUrl: './approval-request-dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDividerModule,
  ],
})
export class ApprovalRequestDialogComponent {
  public readonly Constant = Constant;

  // 承認者
  public approvers: Approver[] = [];
  //public firstApprover: Approver | null = null;
  //public secondApprover: Approver | null = null;
  //public thirdApprover: Approver | null = null;
  private apiPath = '/myevent/request';

  // 送信中フラグ
  public isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<ApprovalRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialog: MatDialog,
    private toastUtil: ToastUtil,
    private auth: AuthService,
    private commonUtil: CommonUtil,
  ) {}

  // 承認者を正規化（2次がnullで3次が存在する場合、3次を2次に繰り上げ）
  //private normalizeApprovers() {
  //  if (this.secondApprover === null && this.thirdApprover !== null) {
  //    this.secondApprover = this.thirdApprover;
  //    this.thirdApprover = null;
  //  }
  //}

  // 承認者選択ダイアログを開く
  onSelectApprovers() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    const dialogRef = this.dialog.open(
      ApproverSelectDialogComponent,
      {
        width: '700px',
        height: '92vh',
        maxHeight: '1200px',
        autoFocus: false,
        disableClose: true,
        data: {
          selectedApprovers: this.approvers,
          eventId: this.data.eventId,
          documentType: this.data.documentType,
        }
      }
    );

    dialogRef.afterClosed().subscribe(
      (result: Approver[] | null) => {

        if (!result) {
          return;
        }

        this.approvers = [...result];
      }
    );
  }

  // 送信ボタンの有効性チェック
  get canSubmit(): boolean {
    return (
      this.approvers.length > 0 &&
      this.approvers.length <= 5 &&
      !this.isSubmitting
    );
  }

  removeApprover(approver: Approver): void {
    this.approvers = this.approvers.filter(
      a => a.id !== approver.id
    );
  }

  // 送信
  onSubmit() {
    console.log(this.data.eventId)
    //if (!this.canSubmit) {
    //  return;
    //}

    const confirmRef = this.dialog.open(GeneralYesNoDialogComponent, {
      width: Constant.dialogWidth,
      autoFocus: false,
      data: {
        msg: '承認依頼を送信します。\n承認進捗中はイベントの編集などができなくなります。\nよろしいですか？',
      },
      disableClose: true,
    });

    confirmRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      }
      this.submitRequest();
    });
  }

  private submitRequest() {
    this.isSubmitting = true;

    // 2次承認者がブランクで3次承認者がいる場合、繰り上げ
    //let approvers = [this.firstApprover, this.secondApprover, this.thirdApprover];
    //approvers = approvers.filter(a => a !== null);

    //const approvers = this.buildApproversForSubmit();

    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        approvers: this.approvers,
        eventId: this.data.eventId,
        document_type: this.data.documentType,
      };
      console.log(options)
      this.commonUtil
        .apiPost(this.apiPath, options)
        .then(res => {
          if (res.status === Constant.OK) {
            this.dialogRef.close(res.status);
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
            this.isSubmitting = false;
          } else if(err.message === '削除済みのユーザーが承認者に含まれています'){
            this.toastUtil.showErrorToast('', Constant.msgRequestDeleteAccountAlreadyError, Constant.toastShowMiliSec);
            this.isSubmitting = false;
          } else if(err.message === '承認に失敗しました。既に差戻しまたは承認済みです。' || err.message === '承認に失敗しました。別のユーザが対応済みです。'){
            this.toastUtil.showErrorToast('', Constant.msgFailedApprovalFlow, Constant.toastShowMiliSec);
            this.dialogRef.close();
            this.isSubmitting = false;
          } else {
            this.toastUtil.showErrorToast('', Constant.msgNetworkError, Constant.toastShowMiliSec);
            this.isSubmitting = false;
          }
        });
    });


  }

  //private buildApproversForSubmit(): Approver[] {
  //  const result: Approver[] = [];

  //  if (this.firstApprover) result.push(this.firstApprover);
  //  if (this.secondApprover) result.push(this.secondApprover);
  //  if (this.thirdApprover) result.push(this.thirdApprover);

  //  return result;
  //}

  // キャンセル
  onCancel() {
    this.dialogRef.close();
  }
}
